<template>
  <div class="mt-8 bg-white shadow-4">
    <div class="flex items-center justify-between border-b-2 border-stroke px-6 py-4">
      <h1 class="border-stroke font-satoshi text-base font-bold text-black">Comparação de Consumo Off-Peak</h1>
    </div>
    <div v-if="series[0].data.length">
      <VueApexCharts class="mt-4 bg-white" type="bar" :options="chartOptions" :series="series" height="400" />
    </div>
    <div v-else class="p-6 text-center text-gray-500">Nenhum dado disponível para exibir.</div>
  </div>
</template>

<script setup lang="ts">
import { useRateStore } from '@/store/rate'
import { useRateChart } from '@/utils/components/rate-chart'
import { storeToRefs } from 'pinia'
import VueApexCharts from 'vue3-apexcharts'

const rateStore = storeToRefs(useRateStore())
const { chartOptions, series } = useRateChart(rateStore.getRateData?.value?.energy_sensors_totalizers || [])
</script>
